const FPS = 1000 / 60
/**
 * class Timer
 */
class Timer {
  /**
   * constructor
   */
  constructor () {
    this.pause = true
    this.timeLastFrame = window.performance.now()
    this.timeCurrentFrame = window.performance.now()
    this.timeEllapsed = 0
    this.time = window.performance.now()
    this.requestAnimationId = null
    this.onFrame = (time, delta) => {}
  }

  nextFrame () {
    this.timeLastFrame = this.timeCurrentFrame
    this.time = window.performance.now()
    this.timeEllapsed = this.time - this.timeLastFrame
    if (this.timeEllapsed >= FPS) {
      this.timeCurrentFrame = this.time
      this.onFrame(this.time, this.timeEllapsed)
    }
    if (!this.pause) this.requestAnimationId = requestAnimationFrame(() => this.nextFrame())
  }

  stop () {
    this.pause = true
    cancelAnimationFrame(this.requestAnimationId)
  }

  play () {
    this.pause = false
    this.nextFrame()
  }

}
export default new Timer()



// WEBPACK FOOTER //
// ./src/scripts/helpers/TimerHelper.js